module.exports = __webpack_public_path__ + "static/media/icon_powerbi-dark.c49cacd3.svg";